var map = {
	"./muro-1.png": 1369,
	"./muro-10.png": 9517,
	"./muro-11.png": 9572,
	"./muro-12.png": 4223,
	"./muro-2.png": 4306,
	"./muro-3.png": 904,
	"./muro-4.png": 6868,
	"./muro-5.png": 6813,
	"./muro-6.png": 5190,
	"./muro-7.png": 1519,
	"./muro-8.png": 9256,
	"./muro-9.png": 3473
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7025;